






























































































































































































// @ is an alias to /src
import { Vue, Component, Prop } from 'vue-property-decorator';
import * as firebase from 'firebase/app';
import { COLLECTION_ORGANIZATIONS, COLLECTION_ROLES, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import Organization from '@/model/Organization';
import OrganizationType from '@/model/typelist/OrganizationType';
import User from '@/model/User';
import StateType from '@/model/typelist/StateType';
import CityType from '@/model/typelist/CityType';
import StatusType from '@/model/typelist/StatusType';
import OrgSubType from '@/model/typelist/OrgSubType';
import Members from '@/model/Member';
import { Cropper } from 'vue-advanced-cropper'
import Post from '@/model/Post';

@Component({
  components: {
    Cropper,
  },
})
export default class RegisterComp extends Vue {
  @Prop({ type: Boolean }) regis!: boolean;

  @Prop({ type: Object }) parentOrg!: any;

  dialog = false;

  searchKey = '';

  selected = false;

  loading = false;

  photoURL = '';

  backPhotoURL = '';

  cropBgImg = '';

  cropProfileImg = '';

  file = {} as any;

  backFile = {} as any;

  $refs!: {
    fileInput: HTMLFormElement;
    backFileInput: HTMLFormElement;
    cropper: HTMLFormElement;
    cropper1: HTMLFormElement;
  };

  pickFile() {
    this.$refs.fileInput.click();
  }

  pickBackFile() {
    this.$refs.backFileInput.click();
  }

  cropPhoto() {
    this.cropProfileImg = this.$refs.cropper.getResult().canvas.toDataURL();
  }

  cropCoverPhoto() {
    this.cropBgImg = this.$refs.cropper1.getResult().canvas.toDataURL();
  }
  // eslint-disable-next-line
  get items() {
    return OrganizationType.allOrgTypes();
  }
  // eslint-disable-next-line
  get states() {
    return StateType.allStates();
  }

  get cities() {
    if (this.Reg.state) {
      return CityType.allCities()
        .filter((city: any) => city.stateType.code === this.Reg.state.code);
    }
    return [];
  }

  // passwordMatch() {
  //   return () => this.password === this.verify || 'Password must match';
  // }
  defaultRegister = {
    orgName: '',
    state: { ...StateType.updateState },
    city: { ...CityType.updateCity },
    orgType: { ...OrganizationType.upDateType },
    moderator: {} as any,
    orgDescription: '',
    orgAddress: '',
  } as any;

  Reg = { ...{}, ...this.defaultRegister };

  onFilePick(event: any) {
    [this.file] = event.target.files;
    const fr = new FileReader();
    fr.onload = () => {
      this.photoURL = fr.result as string;
    };
    fr.readAsDataURL(this.file);
  }

  onPick(event: any) {
    [this.backFile] = event.target.files;
    const fr = new FileReader();
    fr.onload = () => {
      this.backPhotoURL = fr.result as string;
    };
    fr.readAsDataURL(this.backFile);
  }

  register() {
    this.dialog = true;
  }

  submitSearch(searchKey: any) {
    this.$store.dispatch('findModerator', searchKey);
  }

  get moderators() {
    return this.$store.state.moderators;
  }

  get parsedOrg() {
    const orgObj = new Organization(this.Reg.orgName, FirebaseUtil
      .ObjectToRef(COLLECTION_USERS, this.currentUser.uid));
    orgObj.type = { ...this.Reg.orgType };
    orgObj.status = { ...StatusType.waitingForApproval };
    orgObj.city = { ...this.Reg.city };
    orgObj.state = { ...this.Reg.state };
    orgObj.description = this.Reg.orgDescription;
    orgObj.address = this.Reg.orgAddress;
    if (this.regis) {
      orgObj.subType = null;
      orgObj.parent = null;
    } else {
      orgObj.subType = { ...OrgSubType.group };
      orgObj.parent = this.parentOrg.id;
    }
    return orgObj;
  }

  parsedParentOrg(id: any) {
    const clone = { ...this.parentOrg };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, clone.moderator.id);
    const list = [] as any;
    clone.members.forEach((m: any) => {
      const mem = new Members();
      mem.id = m.id;
      mem.status = m.status;
      mem.role = FirebaseUtil.ObjectToRef(COLLECTION_ROLES, m.role.roleType.code);
      list.push({ ...mem });
    });
    clone.members = list;
    clone.groups.push(id);
    return clone;
  }

  // eslint-disable-next-line
  async submit() {
    this.loading = true;
    const org = await this.$store.dispatch('addToCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      payload: { ...this.parsedOrg },
    });
    if (this.cropProfileImg) {
      await this.loadImage(org.id, this.file, this.cropProfileImg).then((result: any) => {
        this.photoURL = result;
      });
    }
    if (this.cropBgImg) {
      await this.loadImage(org.id, this.backFile, this.cropBgImg).then((result: any) => {
        this.backPhotoURL = result;
      });
    }
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: org.id,
      payload: {
        photoURL: this.photoURL,
        backImgURL: this.backPhotoURL,
      },
    });
    if (!this.regis) {
      this.$store.dispatch('updateCollection', {
        collection: COLLECTION_ORGANIZATIONS,
        doc: this.parentOrg.id,
        payload: { ...this.parsedParentOrg(org.id) },
      });
    }
    this.dialog = false;
    this.formClear();
  }
  // eslint-disable-next-line
  async loadImage(id: string, file: any, url: string) {
    let imgUrl = '';
    const promise = await new Promise((resolve: any) => {
      const profileImageRef = firebase
        .storage()
        .ref()
        .child(`${id}/${file.name}`);
      profileImageRef.putString(url, 'data_url').then(() => {
        profileImageRef.getDownloadURL().then((downloadURL: any) => {
          imgUrl = downloadURL;
          resolve();
        });
      });
    });
    return imgUrl;
  }

  close() {
    this.dialog = false;
    this.formClear();
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }

  formClear() {
    this.Reg.orgName = '';
    this.Reg.orgDescription = '';
    this.Reg.state = StateType;
    this.Reg.city = CityType;
    this.Reg.orgType = OrganizationType;
    this.photoURL = '';
    this.backPhotoURL = '';
    this.searchKey = '';
    this.$store.commit('setModEmpty', []);
    this.selected = false;
    this.loading = false;
    this.cropProfileImg = '';
    this.cropBgImg = '';
    this.file = {};
    this.backFile = {};
  }
}
